import { FindFleetInput } from "@shared/types"
import { useFindFleet, Fleet, WithVrns } from "../../api/fleet"
import { useApi } from "./useApi"

export const useFleet = (input: WithVrns<FindFleetInput>) => {
  const [res, reload] = useFindFleet(input)

  return useApi<Fleet, WithVrns<FindFleetInput>>(res, reload)
}
